import axios from '../../axios'

export const countryList = data => {
        return axios({
            url: '/api/base/country',
            method: data.method || 'GET',
            data:data.data
        })
}



// WEBPACK FOOTER //
// ./src/http/moudules/adroad/country.js